import { ListConfigs } from '../../sharedComponent/SearchList/SearchList.types'

export const AGENT_LIST_CONFIGS: ListConfigs[] = [
  {
    headerName: 'Name',
    apiFieldNameFirst: 'agentFirstName',
    apiFieldNameSecond: 'agentLastName',
    type: 'SPACE_SEPERATED',
    columnWidth: '100',
  },
  {
    headerName: 'Email ID',
    apiFieldName: 'agentEmail',
    type: 'TEXT',
    columnWidth: '100',
  },
  {
    headerName: 'User Name',
    apiFieldName: 'loginUsername',
    type: 'TEXT',
    columnWidth: '100',
  },
  {
    headerName: 'Login Password',
    apiFieldName: 'loginPassword',
    type: 'TEXT',
    columnWidth: '100',
  },
  {
    headerName: '# Product Assigned',
    apiFieldName: 'agentProductsCount',
    type: 'TEXT',
    columnWidth: '100',
  },
  {
    headerName: 'Created Date',
    apiFieldName: 'agentCreatedAt',
    type: 'LOCALTIME',
    columnWidth: '75',
  },
  {
    headerName: 'RepId',
    apiFieldName: 'agentRepId',
    type: 'TEXT',
    columnWidth: '75',
  },
  {
    headerName: 'Activation Status',
    apiFieldName: 'isActive',
    type: 'CUSTOM',
    columnWidth: '100',
    info: 'Shows activation status (Pending or Verified). Becomes Verified after email verification and password setup.'
  },
  {
    headerName: 'Active Status',
    apiFieldName: 'isDisabled',
    type: 'ACTIVE_BADGE',
    columnWidth: '100',
  },
  {
    headerName: 'Status',
    apiFieldName: 'agentStatus',
    type: 'STATUS_BADGE',
    columnWidth: '75',
    info: 'Shows status (Pending or Approved). Becomes Approved after System Admin approval.'
  },

]
